import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  error: ''
};

export default function errors (state = initialState, action) {
  const { type, error } = action;

  if (type === types.RESET_ERROR_MESSAGE) {
    return _.merge({}, state, {
      error: ''
    });
  } if (error) {
    return _.merge({}, {
      error
    });
  }

  return state;
}
